import { VdsInlineAlertAppearance, VdsInlineAlertContrastType } from "./types";

export function mapAppearanceToIcon(appearance: VdsInlineAlertAppearance, contrast: VdsInlineAlertContrastType): string {
    switch (appearance) {
        case "success":
            return contrast !== "high" ? "checkmark-filled" : "checkmark-outline";
        case "warning":
            return contrast !== "high" ? "warning-filled" : "warning-outline";
        case "error":
            return contrast !== "high" ? "error-filled" : "error-outline";
        case "neutral":
            return "information-filled";
        case "info":
        default:
            return contrast !== "high" ? "information-filled" : "info";
    }
}
